import React, {useState}  from 'react'
import ICTSelectorFR  from './ICTSelectorSherwood'
import ICTSelectorOMS from './ICTSelectorOMS'
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';
import { PropsSmartFieldLocalized, SmartFieldType } from '..';
import { Grid } from '@mui/material';
import { ButtonCancel } from '../../mini_components';
import { useOffline } from '../../../../hooks';
import { OfflineField } from '../OfflineField';

interface ICTProps extends PropsSmartFieldLocalized{
    label: string;
    resetICTSelectorCallback?: () => void
}
const ICTSelectorGeneral:React.FC<ICTProps> = (props) => {
    const offline = useOffline();

    function getOffline(value:string){
        props.elementSelected({"ict" : value, "ict-code" : "offline"});
    }
    function renderIctSelector(){
        if(offline){
            return <OfflineField label={props.translate(`hospital.select-ict`).toString()} error={props.error} 
                        variant={props.variant} callbackOffline={(value) => getOffline(value)} />
        }
        else{
            if(["en", "es", "ar", "fr"].indexOf(props.language) !== -1 ){
                return <ICTSelectorOMS type={props.type}  variant="outlined" margin={props.typeMargin} 
                            cancel={props.cancel} language={props.language} error={props.error}
                            fullWidth label={props.label}
                            size={props.size} elementSelected={props.elementSelected} 
                            resetICTSelectorCallback = {props.resetICTSelectorCallback}/>
            }
        }
        
    }
    
    return(
        <Grid container spacing={3}>
            <Grid item xs={12}>
                { renderIctSelector() }
            </Grid>
            {
                props.cancel && 
                <Grid item xs={6}>
                    <ButtonCancel onClick={props.cancel} ><Translate id="general.cancel" /></ButtonCancel>
                </Grid> 
            }
        </Grid>)
}
export default withLocalize(ICTSelectorGeneral)